import { legalEN, legalAR } from './translations-legal'
import { siteFooterEN, siteFooterAR } from './translations-sitefooter'
import { homeEN, homeAR } from './translations-home'

const translations = {
  EN: {
    shop: "Shop", login: "Login", register: "Register", myOrders: "My Orders",
    cart: "Cart", logout: "Logout", addToCart: "Add to Cart",
    continueShopping: "Continue Shopping", goToCheckout: "Go to Checkout",
    myStore: "My Store", admin: "Admin", placeOrder: "Place Order",
    total: "Total", search: "Search", allCategories: "All Categories",
    allConditions: "All Conditions", conditionNew: "New", conditionLikeNew: "Like New",
    conditionGood: "Good", conditionFair: "Fair",
    searchPlaceholder: "Search phones, accessories...",
    minPrice: "Min price", maxPrice: "Max price", clearFilters: "Clear filters",
    noProducts: "No products found", loading: "Loading...", found: "products found",
    viewDetails: "View Details", all: "All", to: "to",
    heroTitle: "Qatar's Trusted Tech Marketplace",
    heroSub: "Shop phones, laptops, audio and wearables from verified vendors",
    shopNow: "Shop Now", welcomeBack: "Welcome back",
    email: "Email", password: "Password", noAccount: "No account?",
    invalidCredentials: "Invalid email or password",
    createAccount: "Create Account", fullName: "Full name", phone: "Phone",
    haveAccount: "Have account?", registrationFailed: "Registration failed. Email may already exist.",
    customer: "Customer", vendor: "Vendor", adminRole: "Admin",
    yourCart: "Your Cart", cartEmpty: "Your cart is empty",
    proceedToCheckout: "Proceed to Checkout",
    checkout: "Checkout", shippingAddress: "Shipping Address",
    streetAddress: "Street Address *", city: "City", country: "Country",
    phoneNumber: "Phone Number *", paymentMethod: "Payment Method",
    cashOnDelivery: "Cash on Delivery", creditDebitCard: "Credit / Debit Card",
    cardholderName: "Cardholder Name", placingOrder: "Placing Order...",
    orderSummary: "Order Summary", fillShipping: "Please fill in all required shipping fields",
    orderFailed: "Failed to place order.",
    orderSuccess: "Order Placed Successfully!", orderId: "Order ID",
    status: "Status", deliveryTo: "Delivery to", itemsOrdered: "Items Ordered",
    qty: "Qty", orderNotFound: "Order not found", order: "Order",
    noOrders: "No orders yet", startShopping: "Start Shopping",
    updateFailed: "Failed to update status",
    productNotFound: "Product not found", noRatings: "No ratings yet",
    inStock: "In stock", units: "units", addedToCart: "Added to Cart!",
    itemAddedToCart: "Item added to your cart", loginToAdd: "Please login to add to cart",
    customerReviews: "Customer Reviews", writeReview: "Write a Review",
    yourRating: "Your Rating", shareExperience: "Share your experience...",
    submitReview: "Submit Review", submitting: "Submitting...",
    reviewSubmitted: "Review submitted!", writeComment: "Please write a comment",
    reviewFailed: "Failed to submit review", yourReview: "Your Review",
    delete: "Delete", deleteReviewConfirm: "Delete your review?",
    deleteFailed: "Failed to delete", noReviews: "No reviews yet.",
    adminDashboard: "Admin Dashboard",
    adminSubtitle: "Manage your JASPR Market by JASPR Trading marketplace",
    overview: "Overview", allOrders: "All Orders", users: "Users",
    vendors: "Vendors", payouts: "Payouts", totalOrders: "Total Orders",
    totalRevenue: "Total Revenue", platformFees: "Platform Fees",
    totalUsers: "Total Users", totalVendors: "Total Vendors",
    activeProducts: "Active Products", recentOrders: "Recent Orders",
    addNote: "Add a note (optional):", payoutMarked: "Payout marked as paid!",
    payoutFailed: "Failed to mark payout", totalPlatformRevenue: "Total Platform Revenue",
    totalPendingPayouts: "Total Pending Payouts", vendorPayoutSummary: "Vendor Payout Summary",
    notProvided: "Not provided", totalSales: "Total Sales", platformFee: "Platform Fee (10%)",
    vendorEarning: "Vendor Earning", paid: "Paid", pending: "Pending", markPaid: "Mark Paid",
    products: "Products", orders: "Orders", pendingPayout: "Pending Payout",
    myProducts: "My Products", editProduct: "Edit Product", addProduct: "Add Product",
    bulkUpload: "Bulk Upload", myEarnings: "My Earnings",
    noProductsYet: "No products yet", addFirstProduct: "Add Your First Product",
    stock: "Stock", edit: "Edit", remove: "Remove",
    addNewProduct: "Add New Product", productName: "Product Name *",
    description: "Description", priceQAR: "Price (QAR) *", stockQty: "Stock Qty *",
    selectCategory: "Select Category", productImage: "Product Image",
    uploadFile: "Upload File", imageUrl: "Image URL",
    clickToUpload: "Click to upload", pasteImageUrl: "Paste image URL...",
    removeImage: "Remove image", saving: "Saving...", updateProduct: "Update Product",
    cancel: "Cancel", bulkColumns: "Columns: Name, Description, Price, Stock, CategoryId, Condition",
    selectExcelFile: "Click to select Excel file", uploading: "Uploading...",
    uploadProducts: "Upload Products", yourEarnings: "Your Earnings",
    totalPaid: "Total Paid", yourBankIban: "Your Bank IBAN", save: "Save",
    ibanSaved: "IBAN saved!", ibanFailed: "Failed to save IBAN",
    orderHistory: "Order History", sale: "Sale", fee: "Fee", youGet: "You get",
    productRequired: "Name, price and stock are required",
    productUpdated: "Product updated!", productAdded: "Product added!",
    saveFailed: "Failed to save product", removeProductConfirm: "Remove this product?",
    selectExcel: "Please select an Excel file", bulkFailed: "Bulk upload failed",
    createStore: "Create Your Store", storeName: "Store Name *",
    storeDescription: "Store Description", storeNameRequired: "Store name is required",
    createStoreFailed: "Failed to create store", creating: "Creating...",
    createMyStore: "Create My Store",
    myDocuments: "My Documents",
    documentsNote: "Upload your business documents for verification. Required: CR Copy, Trade License, Authorized Signatory QID.",
    uploadDocument: "Upload Document",
    crCopy: "Commercial Registration (CR) Copy",
    tradeLicense: "Trade License",
    signatoryQID: "Authorized Signatory QID",
    otherDoc: "Other Document",
    clickToUploadDoc: "Click to select document",
    uploadedDocuments: "Uploaded Documents",
    noDocuments: "No documents uploaded yet",
    bankingDetails: "Banking Details",
    bankingNote: "Enter your bank details for payouts. All information is securely stored.",
    accountHolderName: "Account Holder Name",
    bankName: "Bank Name",
    ibanNumber: "IBAN Number",
    accountNumber: "Account Number",
    bankBranch: "Bank Branch",
    saveBankDetails: "Save Bank Details",
    bankingSecurityNote: "Your banking information is encrypted and only accessible to authorized JASPR Market administrators for payout processing.",
    kycDocuments: "KYC Documents",
    kycNote: "Review vendor documents and bank details for compliance verification.",
    noVendors: "No vendors registered yet",
    vendorPendingNote: "Your store registration is pending admin approval. You will be notified by email once approved.",
    pendingApproval: "Store Pending Approval",
    pendingApprovalMsg: "Your store is under review. Our team will approve it within 24 hours.",
    subscriptionInfo: "Subscription Pricing: QAR 1,000 setup fee + QAR 250/month or QAR 500/year renewal.",
    storeRejected: "Store Registration Rejected",
    storeRejectedMsg: "Unfortunately your store registration was not approved. Please contact support.",
    approvals: "Approvals",
    subscriptions: "Subscriptions",
    vendorApprovals: "Vendor Approvals",
    noPendingVendors: "No pending vendor approvals",
    approve: "Approve",
    reject: "Reject",
    addSubscription: "Add Subscription",
    selectVendor: "Select Vendor",
    subscriptionPricing: "Subscription Pricing",
    subscriptionHistory: "Subscription History",
    soldBy: "Sold by", inclVAT: "Inclusive of VAT", condition: "Condition",
    category: "Category", reviews: "reviews", verifiedBuyer: "Verified Buyer",
    freeDelivery: "Free delivery — estimated 2–4 days",
    buyerProtection: "Secure payment & buyer protection",
    easyReturns: "Easy returns within 7 days",
    verifiedSeller: "Verified Seller", shipsIn24h: "Ships in 24h",
    shipsQatar: "Ships within Qatar",
    cookiePolicy: "Cookie Policy",
    vendorPolicy: "Vendor Policy",
    accountDeletionPolicy: "Account Deletion",
    ...legalEN,
    ...siteFooterEN,
    ...homeEN,
       home: 'Home',
       wishlist: 'Wishlist',
       account: 'Account',
       electronics: 'Electronics',
       mobiles: 'Mobiles',
       computers: 'Computers',
       fashion: 'Fashion',
       beauty: 'Beauty',
       homeKitchen: 'Home & Kitchen',
       grocery: 'Grocery',
       sports: 'Sports',
       recentlyViewed: 'Recently Viewed',
       clear: 'Clear',
       verified: 'Verified',
       recommendedForYou: 'Recommended for You',
       topRated: 'Top rated',
       remove: 'Remove',
       audio: 'Audio',
       wearables: 'Wearables',
       comingSoon: 'Coming Soon',
  },
  AR: {
    shop: "تسوق", login: "تسجيل الدخول", register: "إنشاء حساب", myOrders: "طلباتي",
    cart: "السلة", logout: "تسجيل الخروج", addToCart: "أضف إلى السلة",
    continueShopping: "مواصلة التسوق", goToCheckout: "الذهاب إلى الدفع",
    myStore: "متجري", admin: "المشرف", placeOrder: "تأكيد الطلب",
    total: "المجموع", search: "بحث", allCategories: "جميع الفئات",
    allConditions: "جميع الحالات", conditionNew: "جديد", conditionLikeNew: "شبه جديد",
    conditionGood: "جيد", conditionFair: "مقبول",
    searchPlaceholder: "ابحث عن الهواتف والاكسسوارات...",
    minPrice: "أدنى سعر", maxPrice: "أقصى سعر", clearFilters: "مسح الفلاتر",
    noProducts: "لا توجد منتجات", loading: "جار التحميل...", found: "منتجات",
    viewDetails: "عرض التفاصيل", all: "الكل", to: "إلى",
    heroTitle: "سوق قطر الموثوق للإلكترونيات",
    heroSub: "تسوّق الهواتف وأجهزة اللابتوب والصوتيات والأجهزة القابلة للارتداء من بائعين موثوقين",
    shopNow: "تسوق الآن", welcomeBack: "مرحباً بعودتك",
    email: "البريد الإلكتروني", password: "كلمة المرور", noAccount: "ليس لديك حساب؟",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    createAccount: "إنشاء حساب", fullName: "الاسم الكامل", phone: "رقم الهاتف",
    haveAccount: "لديك حساب؟", registrationFailed: "فشل التسجيل. قد يكون البريد الإلكتروني مستخدماً.",
    customer: "عميل", vendor: "بائع", adminRole: "مشرف",
    yourCart: "سلة التسوق", cartEmpty: "سلتك فارغة",
    proceedToCheckout: "المتابعة للدفع",
    checkout: "الدفع", shippingAddress: "عنوان الشحن",
    streetAddress: "عنوان الشارع *", city: "المدينة", country: "الدولة",
    phoneNumber: "رقم الهاتف *", paymentMethod: "طريقة الدفع",
    cashOnDelivery: "الدفع عند الاستلام", creditDebitCard: "بطاقة ائتمان / خصم",
    cardholderName: "اسم حامل البطاقة", placingOrder: "جار تأكيد الطلب...",
    orderSummary: "ملخص الطلب", fillShipping: "يرجى ملء جميع حقول الشحن المطلوبة",
    orderFailed: "فشل تأكيد الطلب.",
    orderSuccess: "تم تأكيد الطلب بنجاح!", orderId: "رقم الطلب",
    status: "الحالة", deliveryTo: "التوصيل إلى", itemsOrdered: "المنتجات المطلوبة",
    qty: "الكمية", orderNotFound: "الطلب غير موجود", order: "طلب",
    noOrders: "لا توجد طلبات بعد", startShopping: "ابدأ التسوق",
    updateFailed: "فشل تحديث الحالة",
    productNotFound: "المنتج غير موجود", noRatings: "لا تقييمات بعد",
    inStock: "المخزون", units: "وحدة", addedToCart: "تمت الإضافة إلى السلة!",
    itemAddedToCart: "تمت إضافة المنتج إلى سلتك", loginToAdd: "يرجى تسجيل الدخول لإضافة المنتج",
    customerReviews: "تقييمات العملاء", writeReview: "اكتب تقييماً",
    yourRating: "تقييمك", shareExperience: "شارك تجربتك...",
    submitReview: "إرسال التقييم", submitting: "جار الإرسال...",
    reviewSubmitted: "تم إرسال التقييم!", writeComment: "يرجى كتابة تعليق",
    reviewFailed: "فشل إرسال التقييم", yourReview: "تقييمك",
    delete: "حذف", deleteReviewConfirm: "هل تريد حذف تقييمك؟",
    deleteFailed: "فشل الحذف", noReviews: "لا توجد تقييمات بعد.",
    adminDashboard: "لوحة تحكم المشرف",
    adminSubtitle: "إدارة سوق موبي مارت من JASPR Trading",
    overview: "نظرة عامة", allOrders: "جميع الطلبات", users: "المستخدمون",
    vendors: "البائعون", payouts: "المدفوعات", totalOrders: "إجمالي الطلبات",
    totalRevenue: "إجمالي الإيرادات", platformFees: "رسوم المنصة",
    totalUsers: "إجمالي المستخدمين", totalVendors: "إجمالي البائعين",
    activeProducts: "المنتجات النشطة", recentOrders: "الطلبات الأخيرة",
    addNote: "أضف ملاحظة (اختياري):", payoutMarked: "تم تسجيل الدفع!",
    payoutFailed: "فشل تسجيل الدفع", totalPlatformRevenue: "إجمالي إيرادات المنصة",
    totalPendingPayouts: "إجمالي المدفوعات المعلقة", vendorPayoutSummary: "ملخص مدفوعات البائعين",
    notProvided: "غير محدد", totalSales: "إجمالي المبيعات", platformFee: "رسوم المنصة (10%)",
    vendorEarning: "أرباح البائع", paid: "مدفوع", pending: "معلق", markPaid: "تسجيل كمدفوع",
    products: "المنتجات", orders: "الطلبات", pendingPayout: "المدفوعات المعلقة",
    myProducts: "منتجاتي", editProduct: "تعديل المنتج", addProduct: "إضافة منتج",
    bulkUpload: "رفع مجمّع", myEarnings: "أرباحي",
    noProductsYet: "لا توجد منتجات بعد", addFirstProduct: "أضف منتجك الأول",
    stock: "المخزون", edit: "تعديل", remove: "حذف",
    addNewProduct: "إضافة منتج جديد", productName: "اسم المنتج *",
    description: "الوصف", priceQAR: "السعر (ريال) *", stockQty: "الكمية *",
    selectCategory: "اختر الفئة", productImage: "صورة المنتج",
    uploadFile: "رفع ملف", imageUrl: "رابط الصورة",
    clickToUpload: "انقر للرفع", pasteImageUrl: "الصق رابط الصورة...",
    removeImage: "حذف الصورة", saving: "جار الحفظ...", updateProduct: "تحديث المنتج",
    cancel: "إلغاء", bulkColumns: "الأعمدة: الاسم، الوصف، السعر، المخزون، معرف الفئة، الحالة",
    selectExcelFile: "انقر لاختيار ملف Excel", uploading: "جار الرفع...",
    uploadProducts: "رفع المنتجات", yourEarnings: "أرباحك",
    totalPaid: "إجمالي المدفوع", yourBankIban: "رقم IBAN البنكي", save: "حفظ",
    ibanSaved: "تم حفظ IBAN!", ibanFailed: "فشل حفظ IBAN",
    orderHistory: "سجل الطلبات", sale: "المبيعات", fee: "الرسوم", youGet: "تحصل على",
    productRequired: "الاسم والسعر والكمية مطلوبة",
    productUpdated: "تم تحديث المنتج!", productAdded: "تمت إضافة المنتج!",
    saveFailed: "فشل حفظ المنتج", removeProductConfirm: "هل تريد حذف هذا المنتج؟",
    selectExcel: "يرجى اختيار ملف Excel", bulkFailed: "فشل الرفع المجمّع",
    createStore: "إنشاء متجرك", storeName: "اسم المتجر *",
    storeDescription: "وصف المتجر", storeNameRequired: "اسم المتجر مطلوب",
    createStoreFailed: "فشل إنشاء المتجر", creating: "جار الإنشاء...",
    createMyStore: "إنشاء متجري",
    myDocuments: "وثائقي",
    documentsNote: "ارفع وثائق عملك للتحقق. المطلوب: نسخة السجل التجاري، الرخصة التجارية، هوية المفوض بالتوقيع.",
    uploadDocument: "رفع وثيقة",
    crCopy: "نسخة السجل التجاري (CR)",
    tradeLicense: "الرخصة التجارية",
    signatoryQID: "هوية المفوض بالتوقيع",
    otherDoc: "وثيقة أخرى",
    clickToUploadDoc: "انقر لاختيار الوثيقة",
    uploadedDocuments: "الوثائق المرفوعة",
    noDocuments: "لم يتم رفع أي وثائق بعد",
    bankingDetails: "البيانات البنكية",
    bankingNote: "أدخل بياناتك البنكية للمدفوعات. جميع المعلومات محفوظة بأمان.",
    accountHolderName: "اسم صاحب الحساب",
    bankName: "اسم البنك",
    ibanNumber: "رقم IBAN",
    accountNumber: "رقم الحساب",
    bankBranch: "فرع البنك",
    saveBankDetails: "حفظ البيانات البنكية",
    bankingSecurityNote: "معلوماتك البنكية مشفرة ولا يمكن الوصول إليها إلا من قبل مديري JASPR Market المعتمدين لمعالجة المدفوعات.",
    kycDocuments: "وثائق KYC",
    kycNote: "مراجعة وثائق البائعين والبيانات البنكية للتحقق من الامتثال.",
    noVendors: "لا يوجد بائعون مسجلون بعد",
    vendorPendingNote: "تسجيل متجرك قيد المراجعة من قبل الإدارة. سيتم إخطارك عبر البريد الإلكتروني عند الموافقة.",
    pendingApproval: "المتجر قيد الموافقة",
    pendingApprovalMsg: "متجرك قيد المراجعة. سيوافق عليه فريقنا خلال 24 ساعة.",
    subscriptionInfo: "أسعار الاشتراك: رسوم إعداد QAR 1,000 + QAR 250 شهرياً أو QAR 500 سنوياً.",
    storeRejected: "تم رفض تسجيل المتجر",
    storeRejectedMsg: "للأسف لم تتم الموافقة على تسجيل متجرك. يرجى التواصل مع الدعم.",
    approvals: "الموافقات",
    subscriptions: "الاشتراكات",
    vendorApprovals: "موافقات البائعين",
    noPendingVendors: "لا توجد موافقات بائعين معلقة",
    approve: "موافقة",
    reject: "رفض",
    addSubscription: "إضافة اشتراك",
    selectVendor: "اختر البائع",
    subscriptionPricing: "أسعار الاشتراك",
    subscriptionHistory: "سجل الاشتراكات",
    soldBy: "يباع بواسطة", inclVAT: "شامل ضريبة القيمة المضافة", condition: "الحالة",
    category: "الفئة", reviews: "تقييمات", verifiedBuyer: "مشترٍ موثق",
    freeDelivery: "توصيل مجاني — خلال 2-4 أيام",
    buyerProtection: "دفع آمن وحماية المشتري",
    easyReturns: "إرجاع سهل خلال 7 أيام",
    verifiedSeller: "بائع موثق", shipsIn24h: "يشحن خلال 24 ساعة",
    shipsQatar: "يشحن داخل قطر",
    cookiePolicy: "سياسة ملفات تعريف الارتباط",
    vendorPolicy: "سياسة البائعين",
    accountDeletionPolicy: "سياسة حذف الحساب",
    ...legalAR,
    ...siteFooterAR,
    ...homeAR,
      home: 'الرئيسية',
  wishlist: 'المفضلة',
  account: 'الحساب',
  electronics: 'الإلكترونيات',
mobiles: 'الجوالات',
computers: 'أجهزة الكمبيوتر',
fashion: 'الأزياء',
beauty: 'الجمال',
homeKitchen: 'المنزل والمطبخ',
grocery: 'البقالة',
sports: 'الرياضة',
recentlyViewed: 'شوهد مؤخراً',
clear: 'مسح',
verified: 'موثّق',
recommendedForYou: 'موصى به لك',
topRated: 'الأعلى تقييماً',
remove: 'إزالة',
audio: 'الصوتيات',
wearables: 'الأجهزة القابلة للارتداء',
comingSoon: 'قريباً',
  },
};

export default translations;
